import { Component } from "react";
import { connect } from "react-redux";
import { quiz4FeedbackAdd } from "../../actions/quiz4OnGoingActions";

class TodoWatch extends Component {
  componentDidMount() {
    const { users } = this.props;
    this.filterTodo(users);
  }

  componentDidUpdate(prevProps, prevState) {
    const { users } = this.props;
    this.filterTodo(users);
  }

  filterTodo = users => {
    const onGoings = Object.entries(users)
      .map(([uid, val]) => ({
        uid,
        ...val
      }))
      .filter(v => v.classCode[v.currentClass]["quiz4OnGoing"] !== undefined);

    this.props.quiz4FeedbackAdd(onGoings);
  };

  render() {
    return false;
  }
}

const mapStateToProps = state => ({
  users: state.users
});
export default connect(
  mapStateToProps,
  { quiz4FeedbackAdd }
)(TodoWatch);
